import { render, staticRenderFns } from "./PlatformRule.vue?vue&type=template&id=25abe0c6&scoped=true"
import script from "./PlatformRule.vue?vue&type=script&lang=js"
export * from "./PlatformRule.vue?vue&type=script&lang=js"
import style0 from "./PlatformRule.vue?vue&type=style&index=0&id=25abe0c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25abe0c6",
  null
  
)

export default component.exports